import React, { Component, useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button, FormGroup, Label, Input } from 'reactstrap';
import "./TermsAcceptModal.css"
import Storage from '../../services/Storage';

export const TermsAcceptModal = ({ isTermModal, onClose, getData, isView = false }) => {
  // const isTermModal = Storage.getIsTermConditionModal();
  const [isAccept, setIsAccept] = useState(false);

  useEffect(() => {
    if (isTermModal) {
      setIsAccept(false);
    }
  }, [isTermModal])

  const handleCheckboxChange = (event) => {
    setIsAccept(event.target.checked);
  };

  const handleSubmitTerms = () => {
    console.log("11111111111111111111")
    if (isAccept && getData) {
      console.log("2222222222222222222")
      getData()
    }
  }

  return (
    <Modal
      isOpen={isTermModal}
      toggle={onClose}
      centered
      scrollable
    >
      <ModalHeader>TERMS AND CONDITIONS</ModalHeader>
      <ModalBody>
        <div className='termsCondition'>
          <p>These Terms & Conditions (“T&Cs”) constitute a legally binding agreement between JK Tyre & Industries Ltd. (“JK Tyre”) and the participating member (“Member”). Participation in the JK Baadshah Redemption Programme (“Programme”) shall be deemed as unconditional acceptance of these T&Cs. JK Tyre reserves the absolute right to modify, amend, suspend, or terminate the Programme or the T&Cs at any time, without prior notice, and such decision shall be final, conclusive, and binding on all Members.</p>
          <ul className='paddingLeft' ordered>
            <li>Enrolment & Eligibility
              <ul className='paddingLeft' disc>
                <li>Enrolment in the Programme is strictly by invitation only. JK Tyre retains absolute and sole discretion to select, approve, reject, or remove Members at any time without assigning any reason.</li>
                <li>The Programme is available only to selected channel partners located in select cities as determined solely by JK Tyre. Eligibility shall be based exclusively on direct purchases made from JK Tyre.</li>
                <li>JK Tyre reserves the right to verify the authenticity, volume, and validity of all purchases claimed by the Member. Any discrepancy found during verification shall entitle JK Tyre to withdraw points, benefits, or membership with immediate effect.</li>
              </ul>
            </li>
            <li>Points Accrual & Valuation
              <ul className='paddingLeft' disc>
                <li>This program is valid only on JK Tyre Truck Bus Radial/Bias Tyres on selected SKUs as mentioned in the CRM policy. Points or reward of the Gift Catalogue cannot be exchanged, transferred or redeemed for cash or credit note.</li>
                <li>Points shall accrue only on specific JK Tyre Truck Bus Radial/Bias SKUs as notified in JK Tyre’s CRM policy. JK Tyre may add, modify, or remove eligible SKUs at its sole discretion.</li>
                <li>JK Tyre holds exclusive rights to determine the calculation, accrual, expiration, and forfeiture of points. JK Tyre’s computation of points shall be final, binding, and nondisputable, except in cases of manifest and proven clerical error.</li>
                <li>The value of loyalty points and rewards shall not be disclosed to Members. Points have no monetary value and cannot be redeemed for cash, credit, or any form of financial instrument.</li>
              </ul>
            </li>
            <li>Redemption Rules
              <ul className='paddingLeft' disc>
                <li>Redemption shall be permitted only during the period declared by JK Tyre. Points can be redeemed only for items listed in the redemption catalogue and strictly subject to availability.</li>
                <li>Once a redemption request is placed, no change, cancellation, or modification shall be permitted.</li>
                <li>JK Tyre may, at any time, alter, replace, or withdraw any reward, brand, model, SKU, or product without prior notice. In case of nonavailability, JK Tyre may offer an alternative item. If the Member declines, points shall only be recredited without any further liability.</li>
                <li>All redeemed vehicle rewards shall be adjusted only against the ex‑showroom Delhi price. Any additional charges including registration, insurance, taxes, accessories, or incidental costs shall be borne solely by the Member.</li>
                <li>For tyre service/equipment, JK Tyre’s responsibility shall be limited strictly to packing, forwarding, freight, installation, commissioning, training, and warranty as provided by the manufacturer. All other costs, including unloading, civil works, electrical/pneumatic connections, consumables, and oils, shall be borne by the Member. JK Tyre does not offer any guarantee/warranty on any of the items redeemed. Standard manufacturer’s guarantee/warranty will be applicable on these items.</li>
                <li>Applicable TDS (10% or prevailing rate) shall be deducted at source. JK Tyre is not responsible for any tax liability arising from redemption benefits.</li>
              </ul>
            </li>
            <li>Product Disclaimer & Liability
              <ul className='paddingLeft' disc>
                <li>JK Tyre does not provide any guarantee or warranty on redeemed items. Only the manufacturer’s standard warranty shall apply.</li>
                <li>Images in the catalogue are indicative; actual product specifications and colour may vary. JK Tyre shall not be liable for any such variation.</li>
                <li>JK Tyre shall have no liability whatsoever for any delay, defect, deficiency, damage, loss, or nonperformance relating to any redeemed product, courier delivery, or manufacturer’s warranty.</li>
                <li>JK Tyre shall not be liable for any direct, indirect, special, incidental, or consequential loss or damage arising out of Programme participation or redemption.</li>
              </ul>
            </li>
            <li>Delivery & Acceptance
              <ul className='paddingLeft' disc>
                <li>Delivery shall be made only to the Member’s registered address. No request for delivery to alternate addresses shall be entertained.</li>
                <li>In case the mailing address has changed recently, please call the program team to request for a change in the registered address. Only after the member receives a confirmation on change of registered address, he can place a request for redemption of item points.</li>
                <li>Delivery shall be considered complete upon written acknowledgment from any person at the registered address. Such acknowledgment shall be treated as acceptance by the Member.</li>
                <li>Any damage or discrepancy must be reported within three (3) days of delivery. Failure to report within this period shall be deemed full acceptance of the item, and no further complaints shall be entertained.</li>
                <li>If the item arrives with visibly damaged packaging, the Member must refuse delivery and obtain a refusal note from the courier. Failure to do so forfeits any claim. The member shall return the package to: <br />The Program Manager, <br />JK Baadshah 716, Binori Bsquare, 3,<br />Sindhubhavan Rd,<br />Bodakdev, Ahmedabad,<br />Gujarat 380054<br />Tele – 8282884646<br />Email: jkbaadshah@trackwalkins.com</li>
              </ul>
            </li>
            <li>Programme Validity & Expiry of Points
              <ul className='paddingLeft' disc>
                <li>The Programme is valid for points earned between 1 April 2024 and 31 March 2025, along with accumulated and unredeemed points up to 31 March 2024.</li>
                <li>Points not redeemed within the declared redemption period will be carried forward.</li>
                <li>JK Tyre retains the right to forfeit points in case of any suspected fraud, misrepresentation, misuse, or violation of Programme conditions.</li>
              </ul>
            </li>
            <li>Governing Law & Jurisdiction
              <ul className='paddingLeft' disc>
                <li>These T&Cs shall be governed exclusively by the laws of India.</li>
                <li>The courts at New Delhi shall have exclusive jurisdiction over all disputes arising out of or in connection with the Programme.</li>
              </ul>
            </li>
            <li>JK Tyre’s Rights & Member’s Obligations
              <ul className='paddingLeft' disc>
                <li>JK Tyre reserves the unconditional right to:</li>
                <ul className='paddingLeft' disc>
                  <li>audit, verify, and investigate any Member's transactions,</li>
                  <li>suspend or terminate membership,</li>
                  <li>withdraw or modify points,</li>
                  <li>alter or discontinue any part of the Programme.</li>
                </ul>
                <li>Members shall:</li>
                <ul className='paddingLeft' disc>
                  <li>provide accurate and verifiable information,</li>
                  <li>comply strictly with these T&Cs,</li>
                  <li>bear all applicable taxes, charges, and costs related to redemption benefits.</li>
                </ul>
                <li>Any breach of these T&Cs shall result in immediate disqualification, forfeiture of points, and possible legal action.</li>
              </ul>
            </li>
          </ul>
          <p>By continuing participation, the Member expressly acknowledges and agrees that JK Tyre’s decisions regarding the Programme shall be final, binding, and nonchallengeable.</p>
        </div>
        {!isView && (
          <div className='d-flex justify-content-between p-3' style={{ width: "100%" }}>
            <div>
              <label className="custom-checkboax1--container">
                <input
                  type="checkbox"
                  name="completed"
                  checked={isAccept}
                  onChange={handleCheckboxChange}
                />
                <span className="checkmark1" />
              </label>
              <span style={{ marginLeft: "10px" }}>
                I agree to the terms and conditions
              </span>
            </div>
            <Button color="primary" disabled={!isAccept} onClick={handleSubmitTerms}>Continue</Button>
          </div>
        )}
      </ModalBody>
      {isView && (
        <ModalFooter>
          <Button color="secondary" onClick={onClose}>Close</Button>
        </ModalFooter>
      )}
    </Modal>
  )
}
